<script>
    import { goto } from "$app/navigation";
    import john from "$lib/assets/images/headshots/john.png";
    import emily from "$lib/assets/images/headshots/emily.png";
    import sarah from "$lib/assets/images/headshots/sarah.png";
    export let btnColor = "variant-filled-secondary";
    import { focusForm } from "$lib/stores/store";
    function handleClick() {
        // if form is on page scroll to it, otherwise go to order page
        const formField = document.querySelector(".form-container");

        if (formField) {
            formField.scrollIntoView({ behavior: "smooth", block: "center" });
            $focusForm = true;
            console.log("focusForm: ", $focusForm);
            // formField.focus();
        } else {
            goto("/order");
        }
    }
</script>

<section>
    <div class="container">
        <div class="header">
            <h2>Don't listen to us, listen to other people like you!</h2>
        </div>

        <div class="cards">
            <div class="card-container">
                <div class="card">
                    <div class="card-header">
                        <img src={sarah} alt="checkmark" />
                    </div>
                    <div class="card-text">
                        <h3>Sarah B.</h3>
                        <p>This is a game-changer for me. As a mom who's always driving my kids around, knowing my car is covered against unexpected repairs gives me real peace of mind.</p>
                    </div>
                </div>
            </div>

            <div class="card-container">
                <div class="card">
                    <div class="card-header">
                        <img src={john} alt="checkmark" />
                    </div>
                    <div class="card-text">
                        <h3>John T.</h3>
                        <p>The program is just what I needed. It covers just about everything and isn't over expensive. Now, I can just enjoy my cars without worrying about repair costs.</p>
                    </div>
                </div>
            </div>

            <div class="card-container">
                <div class="card">
                    <div class="card-header">
                        <img src={emily} alt="checkmark" />
                    </div>
                    <div class="card-text">
                        <h3>Emily C.</h3>
                        <p>They made buying a used car stress-free. It gives me confidence as I start this new chapter in my life. Also, Steven was super nice!</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="footer">
            <button class="btn btn-lg {btnColor} text-white" on:click={handleClick}>Get Certified</button>
        </div>
    </div>
</section>

<style>
    section {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        margin-bottom: 0;
        max-width: 1400px;
        margin: 2rem auto;
    }

    .container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 2rem;
        padding: 2rem 0;
        margin-bottom: 0;
    }

    .header {
        @apply text-center;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        margin-bottom: 0;
    }
    .header h2 {
        color: var(--blue, #272d5b);
        text-align: center;
        font-family: Inter;
        font-size: 40px;
        font-style: normal;
        font-weight: 800;
        line-height: 42px;
    }

    .cards {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        margin-bottom: 0;
    }

    .card-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 2rem;
        padding: 0 2rem;
        margin-bottom: 0;
        border: none;
    }

    .card {
        @apply bg-white p-4 text-center;
        border: 0px solid white;
        box-shadow: none;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        margin-bottom: 0;
        width: 100%;
    }

    .card-header {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 100px;
        gap: 1rem;
        margin-bottom: 0;
    }

    .card-header img {
        width: 200px;
        height: 200px;
    }
    .card-text {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        margin-bottom: 0;
    }
    .card-text h3 {
        color: #000;

        text-align: center;
        /* h3 */
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px;
    }

    .card-text p {
        color: #000;

        text-align: center;
        /* p */
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 150% */
    }

    .card-text p::before {
        @apply text-2xl text-primary-400;
        content: "“ ";
    }
    .card-text p::after {
        @apply text-2xl text-primary-400;

        content: " ”";
    }
    .footer {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 2rem;
        margin-bottom: 0;
    }
    button {
        display: flex;
        width: 360px;
        padding: 15px 20px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        color: #fff;

        font-family: Inter;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px;
    }
    @media screen and (min-width: 768px) {
        .cards {
            flex-direction: row;
            gap: 0rem;
        }

        .card-container {
            max-width: 33.333%;
            overflow: hidden;
            padding: 0;
        }
    }
</style>
